import $ from "jquery";
import app, { vuwer, csl, u_ } from "@@assets/scripts/common";
import * as eyecatch from "./__eyecatch";

const reg = /poster$/i;

const preLoadPosters = Object.keys(eyecatch).map(k => {
	if( !reg.test(k) ) {
		return false;
	}
	
	const path = eyecatch[k];
	return new Promise(resolve => app.imgPreload(path, (err, src, img) => {
		if(err) {
			resolve(false);
		}
		
		const key = k.replace(reg, "");
		const { height, width } = img;
		const ratio = Math.round(height / width * 100) / 100
		
		csl.log.orange(`preloaded ${k}`, { key, height, width, ratio });
		resolve({ key, height, width, ratio });
	}));
});

vuwer.get("pageHeader").setProp({
	async onReady($self) {
		if(!$self) {
			return false;
		}
		
		const $videoContainer = $("#eyecatch_video_container");
		if(!$videoContainer.length) {
			return false;
		}
		
		const videos = {};
		
		const $landscape = $videoContainer.children(".landscape");
		if($landscape.length) {
			$landscape.attr({
				src: eyecatch.landscapeVideo,
				poster: eyecatch.landscapePoster
			});
			
			videos.$landscape = $landscape;
		}
		
		const $portrait = $videoContainer.children(".portrait");
		if($portrait.length) {
			$portrait.attr({
				src: eyecatch.portraitVideo,
				poster: eyecatch.portraitPoster
			});
			
			videos.$portrait = $portrait;
		}
		
		const posters = await Promise.all(preLoadPosters);
		posters.forEach(info => {
			if( u_.isObject(info) ) {
				const k = `$${info.key}`;
				if( u_.hasProperty(videos, k) ) {
					videos[k].poster = info;
				}
			}
		});
		
		this.setProp({ $videoContainer, videos });
		
		vuwer.$window.on("resize", e => {
			clearTimeout(this._resizeTimer);
			this._resizeTimer = setTimeout(() => this.calcVideoSize(), 200);
		});
		
		this.calcVideoSize();
	},
	
	calcVideoSize() {
		const { $videoContainer, videos } = this;
		
		const containerHeight = $videoContainer.height();
		const containerWidth = $videoContainer.width();
		const containerRatio = Math.round(containerHeight / containerWidth * 100) / 100;
		
		Object.keys(videos).forEach(k => {
			const $video = videos[k];
			const { poster } = $video;
			if(poster) {
				const fitTo = (poster.ratio < containerRatio) ? "h" : "w";
				$video.attr({ "data-fit-to": fitTo });
			}
		});
		
		csl.log.grey(`** ${this.getAddress()}: calcVideoSize`);
	}
});
